module.exports = __webpack_public_path__ + "static/media/tube.9745bcca.png";